import {
    ActivityModality,
    CourseDetails,
    CourseProps,
    EvaluationStatus,
    IsProxy,
    LearningActivityStatus,
    RegistrationStatus,
    TranscriptStatus,
    VILTType,
    VIRTUAL_ILT_LOCATION,
} from '../common';

export const TEST_AWS_BUILDER_LABS_URL = 'https://us-east-1.student.classrooms.aws.training';
export const TEST_WEBEX_URL = 'https://prod.evcsp.aurous.training.aws.dev/';
export const TEST_EVALUATION_URL = 'https://amazonmr.au1.qualtrics.com/';
export const TEST_SEATS_LEFT = 5;
export const TEST_TIMEZONE = 'America/Los_Angeles';
export const TEST_LANGUAGE = 'English';
export const TEST_COURSE_NAME = 'Some Catalog Title';
export const TEST_COURSE_ID = '12345';
export const TEST_COURSE_ID2 = '67890';
export const TEST_TRANSCRIPT_ID = '98765';
export const TEST_USER_ID = 'testUserId';
export const TEST_USER_FIRST_NAME = 'testUserFirstName';
export const TEST_USER_LAST_NAME = 'testUserLastName';
export const TEST_USER_EMAIL = 'testUserEmail@test.com';
export const TEST_ORGANIZATION = 'AWS Training';
export const TEST_ORGANIZATION_ID = '910ff767-6fde-4f43-aaba-691778def888';
export const TEST_ORGANIZATION_ID_2 = '910ff767-6fde-4f43-aaba-691778def889';
export const TEST_ORGANIZATION_ID_3 = '910ff767-6fde-4f43-aaba-691778def890';
export const TEST_TEAM_ID = '910ff767-6fde-4f43-aaba-691778def891';

export const createTestSchedule = (
    startDateTime = new Date(),
    endDateTime = new Date(Date.now() + 60 * 60 * 1000),
    timezone = TEST_TIMEZONE,
) => ({
    classDays: [{ startDateTime: startDateTime, endDateTime: endDateTime }],
    timezone: timezone,
    language: TEST_LANGUAGE,
    seatsRemaining: TEST_SEATS_LEFT,
});

export const createTestCourse = (
    courseStatus = LearningActivityStatus.ACTIVE,
    registrationStatus = RegistrationStatus.REGISTERED,
    transcriptStatus = TranscriptStatus.ATTENDED,
    evaluationStatus = EvaluationStatus.INCOMPLETE,
    isProxy = IsProxy.FALSE,
    isPartnerPublicUnlistedClass = false,
): CourseProps => ({
    id: TEST_COURSE_ID,
    courseStatus: courseStatus,
    registrationStatus: registrationStatus,
    transcriptStatus: transcriptStatus,
    evaluationStatus: evaluationStatus,
    schedule: createTestSchedule(),
    classroomUrl: TEST_AWS_BUILDER_LABS_URL,
    meetingLink: TEST_WEBEX_URL,
    evaluationUrl: TEST_EVALUATION_URL,
    courseDetails: {
        name: TEST_COURSE_NAME,
    } as CourseDetails,
    activityModality: ActivityModality.vILT,
    location: VIRTUAL_ILT_LOCATION,
    isProxy,
    isPartnerPublicUnlistedClass,
    commercialPrivateCourseOrgIds: [TEST_ORGANIZATION_ID],
    vIltType: VILTType.WebEx,
});
